/*
 * @Author: wuhao
 * @Date: 2020-04-08 14:28:17
 * @LastEditors: wuhao
 * @LastEditTime: 2020-04-10 17:32:07
 * @Description: 封装table搜索条件
 */

import ApexDialog from './src/index'

ApexDialog.install = function(Vue) {
  Vue.component(ApexDialog.name, ApexDialog)
}

export default ApexDialog
